/**
 *  缓存方法
 */

export default {
  getStorage() {
    return JSON.parse(window.localStorage.getItem('walletMerchant') || '{}')
  },
  setItem(key, value) {
    const storage = this.getStorage()
    storage[key] = value
    window.localStorage.setItem('walletMerchant', JSON.stringify(storage))
  },
  getItem(key) {
    return this.getStorage()[key]
  },
  clearItem(key) {
    const storage = this.getStorage()
    delete storage[key]
    window.localStorage.setItem('walletMerchant', JSON.stringify(storage))
  },
  clearAll() {
    window.localStorage.clear()
  },
}
